import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class AssinaturaEletronicaService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public esqueciMinhaAssinatura(){

    return this.http
                .post(`${environment.apiURL}/Logado/AssinaturaEletronica/EsqueciMinhaAssinatura`, {});
  }

  public alterarAssinatura(dados){

    return this.http
                .post(`${environment.apiURL}/Logado/AssinaturaEletronica/AlterarAssinatura`, dados);
  }

}
